import React, { useEffect, useState } from 'react';
import { NavigationMenu } from '@shopify/app-bridge-react';
import { plans, getResolvedFeatures } from '../plans';
import { config } from '../constants';

const API_BASE = config.API_BASE;

export default function ShopifyNavigation({ navigate, shop }) {
  console.log('[ShopifyNavigation] Rendered, shop:', shop);
  const [features, setFeatures] = useState([]);
  const [plan, setPlan] = useState('Free');

  // Get current path for nav highlighting
  const currentPath = window.location.pathname.replace(/\/$/, '');

  useEffect(() => {
    console.log('[ShopifyNavigation] useEffect triggered, shop:', shop);
    async function fetchPlan() {
      try {
        const res = await fetch(`${API_BASE}/current-plan?shop=${shop}`);
        const data = await res.json();
        console.log('[ShopifyNavigation] Plan fetched:', data?.plan);
        setPlan(data?.plan || 'Free');
        setFeatures(getResolvedFeatures(data?.plan || 'Free', plans));
      } catch {
        console.log('[ShopifyNavigation] Plan fetch failed, defaulting to Free');
        setPlan('Free');
        setFeatures(getResolvedFeatures('Free', plans));
      }
    }
    if (shop) fetchPlan();
    else console.log('[ShopifyNavigation] No shop prop provided!');
  }, [shop]);

  // Define nav items
  const navLinks = [
    {
      label: 'Training',
      destination: '/admin',
      onClick: () => navigate('/admin'),
      isActive: currentPath === '/admin',
    },
    (plan === 'Standard' || plan === 'Premium') && {
      label: 'Chatbox',
      destination: '/chatbox',
      onClick: () => navigate('/chatbox'),
      isActive: currentPath === '/chatbox',
    },
    (plan === 'Standard' || plan === 'Premium') && {
      label: 'Live Chat',
      destination: '/livechat',
      onClick: () => navigate('/livechat'),
      isActive: currentPath === '/livechat',
    },
    {
      label: 'Subscriptions',
      destination: '/subscriptions',
      onClick: () => navigate('/subscriptions'),
      isActive: currentPath === '/subscriptions',
    },
    (plan === 'Standard' || plan === 'Premium') && {
      label: 'Settings',
      destination: '/settings',
      onClick: () => navigate('/settings'),
      isActive: currentPath === '/settings',
    },
    {
      label: 'Help',
      destination: '/help',
      onClick: () => navigate('/help'),
      isActive: currentPath === '/help',
    },
    {
      label: 'What’s New',
      destination: '/upcoming-features',
      onClick: () => navigate('/upcoming-features'),
      isActive: currentPath === '/upcoming-features',
    },
  ].filter(Boolean);

  // Pass isActive to NavigationMenu if supported, or highlight manually if custom sidebar
  return (
    <NavigationMenu
      navigationLinks={navLinks.map(({ isActive, ...rest }) => rest)}
      // If you use a custom sidebar, use isActive to highlight
    />
  );
}
